"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRotableBondCount = getRotableBondCount;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the rotable bond count of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns ComputedData
 */
function getRotableBondCount(data) {
    const rotableBondCount = (0, getNumberProperties_1.getNumberProperties)(data, 'Rotatable Bond Count');
    return rotableBondCount;
}
//# sourceMappingURL=getRotableBondCount.js.map